import { createTheme, ThemeProvider } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      50: '#ECF3FF',
      100: '#DCE8FF',
      200: '#C0D4FF',
      300: '#99B6FF',
      400: '#718CFF',
      500: '#5064FF',
      600: '#2028FA',
      700: '#2427DE',
      800: '#2127B2',
      900: '#23298C',
      950: '#151851',
    },
    secondary: {
      main: '#FFB300',
    },
    success: {
      main: '#2E7D32',
    },
    info: {
      main: '#0288D1',
    },
    danger: {
      main: '#D32F2F',
    },
    text: {
      main: '#151851',
      secondary: 'rgba(21, 24, 81, 0.6)',
      contrastText: '#FFFFFF',
    },
    white: {
      main: '#FFFFFF',
    },
    grey: {
      main: '#F5F5F5',
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          color: 'pink',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          color: '#151851',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '0.25rem',
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
  typography: {
    allVariants: {
      color: '#151851',
    },
    fontFamily: ['Lato'],
    subtitle1: {
      fontSize: '1.125rem',
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFFFFFB2',
    },
    text: {
      main: '#FFFFFFB2',
    },
  },
  typography: {
    allVariants: {},
    fontFamily: ['Lato'],
    subtitle1: {
      fontSize: '1.125rem',
    },
  },
});

export function DarkProvider({ children }) {
  return <ThemeProvider theme={darkTheme}>{children}</ThemeProvider>;
}

export function LightProvider({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
